const initialState = {
  log: [],
  state: {},
  view: 3, //1=debug 2=log 3=console
};

const debugReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOG":
      state.log.push(action.payload);
      break;
    case "DEBUG":
      state.state[action.payload.name] = JSON.stringify(action.payload.value);
      break;
    case "DEBUGVIEW":
      state = {
        ...state,
        view: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
};

export default debugReducer;






// WEBPACK FOOTER //
// ./src/reducers/debugReducer.js